/*! *********************************************************************
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import Grid from '@material-ui/core/Grid';
import React, { useEffect, useState } from 'react';
import {
  ArrayInput,
  FormTab,
  NumberInput,
  required,
  SimpleFormIterator,
  TabbedForm,
  TextInput,
  SelectInput,
} from 'react-admin';

import _map from 'lodash/map';

import PreviewFileInput from '../../components/PreviewFileInput';
import PreviewPlaceholder from '../../components/PreviewPlaceholder';
import StatusSelectorInput from '../../components/StatusSelectorInput';
import validateTheme from './validation';

import collectionsQuery from '../../graphql/collections.gql';
import apolloClient from '../../services/apollo-client';

const CreateOrUpdateFrom = (props) => {
  const [state, setState] = useState({ collections: [], loading: true });

  useEffect(() => {
    async function fetchAllCollections() {
      let collections = [];
      let page = 0;

      // get assets chunk until all the assets have been fetch
      while (true) {
        const response = await apolloClient.query({
          query: collectionsQuery,
          variables: {
            page,
            limit: 100,
          },
        });

        collections = [...collections, ...response.data.collections.items];

        const hasMore = response.data.collections.hasMore ?? false;
        if (!hasMore) {
          break;
        }

        ++page;
      }

      setState({ collections, lodaing: false });
    }
    fetchAllCollections();
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      <TabbedForm {...props} validate={validateTheme}>
        <FormTab label="Base fields">
          <React.Fragment>
            <TextInput source="title" validate={[required()]} fullWidth />
            <TextInput
              label="Description (SEO only)"
              source="description"
              fullWidth
              multiline
            />
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <NumberInput
                  source="weight"
                  label="Position"
                  min={0}
                  step={1}
                  helperText="Lower means first to be display, starting at 0. Empty adds theme to the end of the list"
                />
              </Grid>
              <Grid item>
                <StatusSelectorInput source="status" />
              </Grid>
            </Grid>
            <PreviewFileInput
              source="imageUrl"
              placeholder={<PreviewPlaceholder />}
            />
          </React.Fragment>
        </FormTab>
        <FormTab label="Collections">
          {!state.loading ? (
            <ArrayInput source="collections" label="Collections">
              <SimpleFormIterator>
                <SelectInput
                  choices={_map(state.collections, (c) => ({
                    id: c.id,
                    name: c.title,
                  }))}
                  translateChoice={false}
                  emptyText="Pick a collection"
                />
              </SimpleFormIterator>
            </ArrayInput>
          ) : (
            <>
              <div>Loading....</div>
            </>
          )}
        </FormTab>
      </TabbedForm>
    </div>
  );
};

export default CreateOrUpdateFrom;
